import {Scene} from 'three';
import {Mesh} from 'three';
import {PerspectiveCamera, BoxGeometry} from 'three';
import {Material} from 'three';
import {BaseBuilderMatNodeType} from '../../../../../../@polygonjs/polygonjs/src/engine/nodes/mat/_BaseBuilder';
import {StoreController} from '../../../../store/controllers/StoreController';

export class MaterialCompileHelper {
	private static _scene = this._createMatCompileScene();
	private static _camera = new PerspectiveCamera();
	private static _mesh = new Mesh();
	static async compile(matNode: BaseBuilderMatNodeType | Material) {
		const renderer = await StoreController.engine.scene.renderersRegister.waitForRenderer();
		if (!renderer) {
			console.error('no renderer found');
			return;
		}
		let material: Material;
		if (matNode instanceof Material) {
			material = matNode;
		} else {
			material = await matNode.material();
		}
		this._mesh.material = material;
		renderer.compile(this._mesh, this._camera);
	}
	private static _createMatCompileScene(): Scene {
		this._scene = new Scene();
		this._mesh = new Mesh(new BoxGeometry(1, 1, 1));
		this._mesh.frustumCulled = false;
		this._camera = new PerspectiveCamera();
		this._camera.position.z = 5;
		this._camera.updateMatrix();
		this._scene.add(this._mesh);
		this._scene.add(this._camera);
		return this._scene;
	}
}
